import { render, staticRenderFns } from "./index.vue?vue&type=template&id=720b34ff&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=720b34ff&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720b34ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('720b34ff')) {
      api.createRecord('720b34ff', component.options)
    } else {
      api.reload('720b34ff', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=720b34ff&scoped=true", function () {
      api.rerender('720b34ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/ezpay/components/MessageManage/index.vue"
export default component.exports